import React, { forwardRef } from 'react';
import { DropdownLayoutProps } from '.';
import {
  OverlayScrollbarContent,
  OverlayScrollbarHost,
  useOverlayScrollbar,
} from '../providers/useOverlayScrollbar/useOverlayScrollbar';
import { DropdownLayout } from './DropdownLayout';

export type WithOverlayScrollbarProps = {
  overlayScrollbarProps?: {
    OverlayScrollbarHostElement: OverlayScrollbarHost;
    OverlayScrollbarContentElement: OverlayScrollbarContent;
  };
  ref?: React.ForwardedRef<DropdownLayout>;
};

type Props = DropdownLayoutProps & WithOverlayScrollbarProps;

const withOverlayScrollbar = (WrappedComponent: typeof DropdownLayout) => {
  return forwardRef<DropdownLayout, Props>(
    (props: DropdownLayoutProps, ref) => {
      const [OverlayScrollbarHostElement, OverlayScrollbarContentElement] =
        useOverlayScrollbar();

      return (
        <WrappedComponent
          {...props}
          ref={ref}
          overlayScrollbarProps={{
            OverlayScrollbarHostElement,
            OverlayScrollbarContentElement,
          }}
        />
      );
    },
  );
};

export { withOverlayScrollbar };
